<template>
  <path
    d="M18 9.50024V6.00024C18 5.45024 17.55 5.00024 17 5.00024H3C2.45 5.00024 2 5.45024 2 6.00024V18.0002C2 18.5502 2.45 19.0002 3 19.0002H17C17.55 19.0002 18 18.5502 18 18.0002V14.5002L20.29 16.7902C20.92 17.4202 22 16.9702 22 16.0802V7.91024C22 7.02024 20.92 6.57024 20.29 7.20024L18 9.50024ZM13 15.5002V13.0002H7V15.5002L3.85 12.3502C3.65 12.1502 3.65 11.8402 3.85 11.6402L7 8.50024V11.0002H13V8.50024L16.15 11.6502C16.35 11.8502 16.35 12.1602 16.15 12.3602L13 15.5002Z"
  />
</template>
